import React from "react"
import styled from "styled-components"
import { FaRegFileAlt, FaQuestionCircle } from "react-icons/fa"
import { Link } from "gatsby"
import { connectHits, Highlight } from "react-instantsearch-dom"

export const SearchResult = connectHits(({ hits, active }) => {
  return (
    <>
      {active && (
        <Wrapper>
          <ResultList>
            {hits.length > 0 ? (
              hits.map((hit, index) => (
                <ResultItem key={index}>
                  <StyledLink to={`/documents/${hit.slug}/`}>
                    <TitleWrapper>
                      <Title>
                        <FaRegFileAlt />{" "}
                        <Highlight attribute="title" hit={hit} />
                      </Title>
                      {hit.products ? (
                        <span>Product Documentation</span>
                      ) : hit.configurations ? (
                        <span>Configuration Documentation</span>
                      ) : (
                        <span>Miscellaneous Documentation</span>
                      )}
                    </TitleWrapper>
                    <NumberOfHits>
                      {hit.files} {hit.files === 1 ? "file" : "files"}
                    </NumberOfHits>
                  </StyledLink>
                </ResultItem>
              ))
            ) : (
              <ResultItem>
                <StyledLink to={`#`}>
                  <h4>
                    <FaQuestionCircle /> No results...
                  </h4>
                </StyledLink>
              </ResultItem>
            )}
          </ResultList>
        </Wrapper>
      )}
    </>
  )
})

const Wrapper = styled.div`
  position: absolute;
  background-color: #333;
  color: #000;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #000;

  .theme-dark & {
    background-color: #fff;
    color: #000;
  }
`

const ResultList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const StyledLink = styled(Link)`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-decoration: none;
  color: #fff;

  &:hover {
    background-color: #555;
  }

  .theme-dark & {
    color: #000;

    &:hover {
      background-color: #eee;
    }
  }
`

const ResultItem = styled.li`
  &:not(:last-child) {
    border-bottom: 1px solid #555;

    .theme-dark & {
      border-color: #333;
    }
  }
`

const TitleWrapper = styled.div`
  display: block;

  > span {
    font-size: 14px;
    opacity: 0.7;
  }

  em {
    background-color: tomato;
  }
`
const Title = styled.h4`
  margin-bottom: 5px;
  margin-top: 0;
`

const NumberOfHits = styled.span`
  white-space: nowrap;
`
